import { Project } from '../pages/Projects';

export const documentProjects: Project[] = [
  {
    id: 'doc-bangbae-housing',
    title: '방배동 장기전세주택건립사업',
    category: '주거',
    subcategory: '장기전세주택',
    year: '2024',
    location: '서초구 방배동 911-11번지 일원',
    client: '공공/민간 개발사업',
    role: 'PM : 진행중인 사업',
    image: '/images/projects/bangbae-housing.jpg',
    gallery: [
      '/images/projects/bangbae-housing.jpg'
    ],
    description: '서초구 방배동 911-11번지 일원에 추진 중인 장기전세주택 건립사업입니다. 지하 4층~지상 25층(최고높이 75.20m), 연면적 24,312.60㎡(지상 15,173.31㎡ / 지하 9,139.29㎡) 규모로 조성되며, 공동주택 총 140세대(분양 103세대 / 공공임대 37세대), 부대복리시설 및 공영주차장(195대)을 복합 구축합니다. 빅플래너파트너스가 종합 PM을 맡아 인허가 단계부터 개발기획 및 사업관리를 총괄 수행하고 있습니다.',
    challenge: '서초구 도심 주거 밀집지역 내에서 기준 200% 이하, 상한 500% 이하의 용적률 규제 속에 계획 용적률 476.41%를 효율적으로 확보하고, 공공임대 37세대와 일반분양 103세대의 품질 조화 및 법정 대수(182대)를 상회하는 195대의 주차 인프라를 지하 공간에 안전하게 배치해야 했습니다.',
    solution: '토지 가치를 극대화하는 입체적 배치 계획을 통해 최고 높이 75.20m의 현대적 랜드마크 스카이라인을 확보하고, 지하 4개 층 굴착을 통해 여유로운 공영 및 세대 주차 공간을 실현했습니다. 공공성과 상업성을 아우르는 서초구 대표 장기전세주택 모델을 성공적으로 도출했습니다.',
    zoning: '공동주택 및 부대복리시설, 공영주차장',
    land_area: '3184.95',
    building_area: '1790.72',
    total_floor_area: '24312.60',
    scale: '지하 4층 ~ 지상 25층 (최고높이 75.20m)',
    far: '476.41',
    bcr: '56.22',
    units: '총 140세대 (분양 103세대 / 공공임대 37세대)',
    parking: '195대 (법정 182대)',
    notes: 'PM : 진행중인 사업 | 용적률 계획: 기준 200% 이하 / 상한 500% 이하 (계획 476.41%) | 연면적: 지상 15,173.31㎡ / 지하 9,139.29㎡',
    created_at: '2024-06-01T00:00:00+09:00'
  },
  {
    id: 'doc-anyang-wellness',
    title: '안양 메디컬웰니스개발사업',
    category: '복합개발',
    subcategory: '메디컬 웰니스',
    year: '2024',
    location: '경기도 안양시 만안구 안양동 622-89외 3필지',
    client: '메디컬 웰니스 개발 컨소시엄',
    role: 'PM : 진행중인 사업',
    image: '/images/projects/anyang-wellness.jpg',
    gallery: [
      '/images/projects/anyang-wellness.jpg'
    ],
    description: '경기도 안양시 만안구 안양동 622-89외 3필지 일반상업지역에 건립되는 지하 5층~지상 49층 초대형 메디컬 웰니스 복합개발 프로젝트입니다. 전체 연면적 77,656.30㎡(23,491.03평, 지상 53,536.87㎡), 총 410세대의 주거 공간과 전문 의료 클리닉, 헬스케어 및 웰니스 복합시설이 집약된 안양 도심의 랜드마크 타워입니다.',
    challenge: '일반상업지역 내 816.73%에 달하는 초고용적률을 효율적으로 배분하고, 49층 초고층 구조의 안전성 확보와 함께 메디컬 내방객과 410세대 주거 입주민의 동선을 철저히 분리해야 하는 복합 설계 과제가 요구되었습니다.',
    solution: '저층부는 보행 접근성이 뛰어난 메디컬 웰니스 특화 포디움으로, 상층부는 410세대의 프라이빗 주거 타워로 입체 분리 설계했습니다. 매입면적 6,555.00㎡ 중 6,305.00㎡ 사업면적을 정밀하게 계획하여 안양의 스카이라인을 대표하는 혁신적 메디컬 웰니스 타워를 기획했습니다.',
    zoning: '일반상업지역',
    land_area: '6305.00',
    building_area: '',
    total_floor_area: '77656.30',
    scale: '지하 5층 ~ 지상 49층',
    far: '816.73',
    bcr: '57.97',
    units: '410세대',
    parking: '자주식 및 스마트 주차 시스템',
    notes: 'PM : 진행중인 사업 | 매입면적: 6,555.00㎡ (1,982.89평) / 사업면적: 6,305.00㎡ (1,907.26평) | 지상연면적: 53,536.87㎡ (16,194.90평)',
    created_at: '2024-06-02T00:00:00+09:00'
  },
  {
    id: 'doc-yangpyeong-wellness',
    title: '양평 스마트팜 웰니스파크',
    category: '복합개발',
    subcategory: '노유자시설 · 스마트팜',
    year: '2024',
    location: '경기도 양평군',
    client: '웰니스파크 개발단',
    role: 'PM : 진행중인 사업',
    image: '/images/projects/yangpyeong-wellness.jpg',
    gallery: [
      '/images/projects/yangpyeong-wellness.jpg'
    ],
    description: '경기도 양평군의 쾌적한 자연 경관 속에 대지면적 16,668.00㎡(5,042.05평), 연면적 17,283.60㎡(5,228.27평) 규모로 추진되는 친환경 스마트팜 웰니스파크 건립사업입니다. 주용도 노유자시설과 ICT 기반 첨단 스마트팜, 자연 힐링 산책로 및 치유 프로그램이 결합된 지속 가능한 에코 웰니스 복합 공간입니다.',
    challenge: '계획관리지역 및 보전관리지역의 환경 보존 지침을 충실히 반영하면서 대규모 대지 내 노유자 케어 시설과 스마트팜 체험 공간의 안전한 무장애(Barrier-Free) 유기적 연결 동선을 구현해야 했습니다.',
    solution: '자연 지형과 조화를 이루는 저밀도 친환경 테라스 건축(건폐율 28.26%, 용적률 81.01%)을 채택하고 지하 1층~지상 4층 규모로 편안한 휴양 환경을 조성했습니다. 법정 기준(72대)을 크게 웃도는 128대의 넉넉한 주차 공간을 확보하여 방문 편의성을 극대화했습니다.',
    zoning: '계획관리지역, 보전관리지역',
    land_area: '16668.00',
    building_area: '4710.00',
    total_floor_area: '17283.60',
    scale: '지하 1층 ~ 지상 4층',
    far: '81.01',
    bcr: '28.26',
    parking: '128대 (법정 72대)',
    notes: 'PM : 진행중인 사업 | 주용도: 노유자시설 | 연면적: 지상 13,503.00㎡ / 지하 3,780.60㎡ | 대지 5,042.05평',
    created_at: '2024-06-03T00:00:00+09:00'
  },
  {
    id: 'doc-isu-residence',
    title: '이수역 래지던스호텔 주상복합 개발사업',
    category: '복합개발',
    subcategory: '래지던스호텔 주상복합',
    year: '2024',
    location: '서울 동작구 사당동 136-1 외 14필지',
    client: '㈜대우건설 (시공 예정)',
    role: '개발기획 및 PM (검토중인 사업)',
    contractor: '㈜대우건설 (예정)',
    period: '약 50개월',
    image: '/images/projects/isu-residence.jpg',
    gallery: [
      '/images/projects/isu-residence.jpg'
    ],
    description: '서울 지하철 이수역 초역세권(이수3 특별계획구역) 중심에 계획된 지하 8층~지상 42층 규모의 하이엔드 복합 랜드마크 타워 \'LUMIÈRE Hotel & Residences\' 개발사업입니다. 총연면적 68,313㎡(20,665평) 규모로 저층부 아트리움 & 로비, 글로벌 수준의 부티크 호텔, 최고급 서비스드 레지던스, 루프탑 인피니티 풀 & 스카이 가든이 결합된 서울 서남권 최고급 주상복합입니다.',
    challenge: '이수3 특별계획구역 내 15개 필지 대규모 토지 매입 및 통합 인허가, 용적률 999.26%(최대 1,094% 가능)의 고밀도 입체 복합화, 지하 8층 대심도 굴착 공사에 따른 구조 안전성 확보가 주요 과제였습니다.',
    solution: '국내 대표 건설사인 ㈜대우건설과의 시공 협력 체계를 구축하고, 약 50개월의 철저한 공정 관리 모델을 수립했습니다. 법정(416.5대)을 초과하는 442대의 주차 시설과 랜드마크 외관 디자인을 통해 사업성과 미래 가치를 극대화했습니다.',
    zoning: '일반상업지역 / 이수3 특별계획구역',
    land_area: '4235.2',
    building_area: '',
    total_floor_area: '68313',
    scale: '지하 8층 ~ 지상 42층',
    far: '999.26',
    bcr: '58.45',
    parking: '442대 (법정 416.5대)',
    notes: '계획안 : 검토중인 사업 | 건축 조감도: LUMIÈRE Hotel & Residences (저층부 아트리움 & 로비, 조감 전경-타워, 루프탑 풀 & 가든) | 매입면적: 4,789.3㎡ (1,449평) / 사업면적: 4,235.2㎡ (1,281평) | 공사기간: 약 50개월',
    created_at: '2024-06-04T00:00:00+09:00'
  },
  {
    id: 'doc-sillim-medical',
    title: '신림 메디컬레지던스 개발사업',
    category: '복합개발',
    subcategory: '메디컬 레지던스',
    year: '2024',
    location: '서울특별시 관악구 신림동 1433-1 외 15필지',
    client: '신림 복합개발 컨소시엄',
    role: '개발기획 및 PM (검토중인 사업)',
    image: '/images/projects/sillim-medical.jpg',
    gallery: [
      '/images/projects/sillim-medical.jpg'
    ],
    description: '서울특별시 관악구 신림동 1433-1 외 15필지 일반상업지역에 조성되는 지하 7층~지상 20층 규모의 메디컬 레지던스 복합 개발사업입니다. 대지면적 3,716.15㎡(1,124.14평, 제척부지 23.55㎡ 제외), 연면적 47,122.61㎡(14,279.58평, 지상 29,717.98㎡ / 지하 17,404.63㎡) 규모로 총 354세대의 주거 공간과 450대의 여유로운 주차 공간, 특화 메디컬 클리닉이 결합된 도심 복합 개발 프로젝트입니다.',
    challenge: '신림 역세권 상업밀집지 16개 필지 통합에 따른 제척부지 정리 및 정형화, 용적률 799.7% 및 건폐율 60.33%의 상한 적용, 지하 7층 대심도 시공에 따른 공기 단축과 안전성 관리가 핵심 과제였습니다.',
    solution: '정밀 권리 분석을 통해 제척부지를 제외한 3,716.15㎡의 최적화된 사업면적을 확정하고, 법정 기준을 훌쩍 넘는 450대 주차 인프라를 확보했습니다. 전문 메디컬 테넌트와 상층부 354세대 주거를 연계한 웰니스 라이프케어 복합 단지 모델을 수립했습니다.',
    zoning: '도시지역, 일반상업지역',
    land_area: '3716.15',
    building_area: '2241.88',
    total_floor_area: '47122.61',
    scale: '지하 7층 ~ 지상 20층',
    far: '799.7',
    bcr: '60.33',
    units: '354세대',
    parking: '450대',
    notes: '계획안 : 검토중인 사업 | 매입면적: 3,739.70㎡ (1,131.26평) / 사업면적: 3,716.15㎡ (1,124.14평) — 제척부지 23.55㎡ 제외 | 연면적: 지상 29,717.98㎡ / 지하 17,404.63㎡',
    created_at: '2024-06-05T00:00:00+09:00'
  }
];

export function mergeWithDocumentProjects(fetchedProjects: Project[]): Project[] {
  const existingTitles = new Set(fetchedProjects.map(p => p.title.trim()));
  const missingDocProjects = documentProjects.filter(dp => !existingTitles.has(dp.title.trim()));
  // Put the 5 featured document projects at the front so they are immediately visible
  return [...missingDocProjects, ...fetchedProjects];
}
